import React from "react";
import { NO_OP } from "utils/action";
import classnames from "classnames";

const DEFAULT_CLASSES = {
  container:
    "flex flex-row items-stretch hairline-1 h2 br--right br2 bt bb br bl",
  color: "color-preview br2 w2 h-auto br--left br hairline-1",
  hex: "f6 fw5 self-center ph2 ttu"
};

const ColorField = ({ color, customClasses, onClick }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const handler = onClick || NO_OP;

  return (
    <div
      className={classnames(classes.container, {
        pointer: onClick
      })}
      onClick={handler}
    >
      <div className={classes.color}>
        <style jsx>{`
          .color-preview {
            background-color: ${color};
          }
        `}</style>
      </div>
      <div style={{ minWidth: 76 }} className={classes.hex}>
        {color}
      </div>
    </div>
  );
};

export default ColorField;
